// Фирменные SVG-элементы А.Т.И.К.А. арт клуба

// Каллиграфический разделитель в духе росчерков логотипа
export const Ornament = ({ color = "#8D414B", width = 140, opacity = 1 }) => (
  <svg
    width={width}
    height="16"
    viewBox="0 0 140 16"
    fill="none"
    style={{ opacity }}
    aria-hidden="true"
  >
    <path
      d="M4 8c14 0 22-5.5 34-5.5S56 8 62 8"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M136 8c-14 0-22 5.5-34 5.5S84 8 78 8"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <rect
      x="66.5"
      y="4.5"
      width="7"
      height="7"
      transform="rotate(45 70 8)"
      fill={color}
    />
    <circle cx="4" cy="8" r="1.6" fill={color} />
    <circle cx="136" cy="8" r="1.6" fill={color} />
  </svg>
);

// Палитра художника — для групповых бесед
export const PaletteIcon = ({ size = 20, color = "#FBF0D9" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10c1.38 0 2.5-1.12 2.5-2.5 0-.61-.23-1.2-.64-1.67-.08-.1-.13-.21-.13-.33 0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm5.5 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-3-4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zM5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5zm6-4c0 .83-.67 1.5-1.5 1.5S8 8.33 8 7.5 8.67 6 9.5 6s1.5.67 1.5 1.5z" />
  </svg>
);

// Перо-отправка
export const SendIcon = ({ size = 18, color = "#FBF0D9" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <path d="M3.4 20.4l17.45-7.48c.81-.35.81-1.49 0-1.84L3.4 3.6c-.66-.29-1.39.2-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z" />
  </svg>
);

// Закладка — «Избранное»
export const BookmarkIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <path d="M6 2h12a1 1 0 011 1v18.3a.7.7 0 01-1.1.57L12 17.6l-5.9 4.27A.7.7 0 015 21.3V3a1 1 0 011-1z" />
  </svg>
);

// Иконки полей профиля
export const MailGlyph = ({ size = 15, color = "#8D414B" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="2.5" y="4.5" width="19" height="15" rx="2.5" stroke={color} strokeWidth="1.7" />
    <path d="M3.5 6.5l7.4 5.6a2 2 0 002.2 0l7.4-5.6" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export const PhoneGlyph = ({ size = 15, color = "#8D414B" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <path d="M6.6 2.9a1.6 1.6 0 012.3.5l1.6 2.7c.4.7.3 1.6-.3 2.1l-1 .9c-.2.2-.3.5-.2.8.5 1.4 2 2.9 3.4 3.4.3.1.6 0 .8-.2l.9-1c.5-.6 1.4-.7 2.1-.3l2.7 1.6c.8.5 1 1.5.5 2.3l-1 1.4c-.6.8-1.6 1.2-2.6 1-4.9-1-8.8-4.9-9.8-9.8-.2-1 .2-2 1-2.6l1.6-.8z" />
  </svg>
);

export const BrushGlyph = ({ size = 15, color = "#8D414B" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M14.5 3.5l6 6-7.6 7.6a3 3 0 01-1.5.8l-3.6.8.8-3.6a3 3 0 01.8-1.5L14.5 3.5z" stroke={color} strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M5 21c1.7 0 3-1.3 3-3H5v3z" fill={color} />
  </svg>
);

// Корона — права админа
export const CrownIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <path d="M3 7l4.5 4L12 5l4.5 6L21 7l-1.6 10.5a1.5 1.5 0 01-1.48 1.27H6.08a1.5 1.5 0 01-1.48-1.27L3 7zm3.35 9.77h11.3l.9-5.87-2.72 2.42L12 8.2l-3.83 5.12-2.72-2.42.9 5.87z" />
  </svg>
);

// Корзина — удаление
export const TrashIcon = ({ size = 15, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color} aria-hidden="true">
    <path d="M9 3h6a1 1 0 011 1v1h4a1 1 0 010 2h-1.06l-.86 12.14A2.5 2.5 0 0115.59 21H8.41a2.5 2.5 0 01-2.49-1.86L5.06 7H4a1 1 0 010-2h4V4a1 1 0 011-1zm1 2h4V4h-4v1zM7.07 7l.84 11.86a.5.5 0 00.5.44h7.18a.5.5 0 00.5-.44L16.93 7H7.07zM10 9.5a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6A.75.75 0 0110 9.5zm4 0a.75.75 0 01.75.75v6a.75.75 0 01-1.5 0v-6a.75.75 0 01.75-.75z" />
  </svg>
);

// Мольберт — пустое состояние чата
export const EaselArt = ({ width = 150 }) => (
  <svg
    width={width}
    height={width}
    viewBox="0 0 150 150"
    fill="none"
    aria-hidden="true"
  >
    {/* холст */}
    <rect
      x="35"
      y="24"
      width="80"
      height="58"
      rx="4"
      stroke="#243D27"
      strokeWidth="2.5"
      fill="#FDF7E9"
    />
    {/* мазок кисти на холсте */}
    <path
      d="M48 58c10-16 22 6 34-8 8-9 14-2 20 2"
      stroke="#8D414B"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle cx="52" cy="40" r="3.5" fill="#243D27" opacity="0.55" />
    {/* верхняя перекладина */}
    <path d="M30 24h90" stroke="#243D27" strokeWidth="2.5" strokeLinecap="round" />
    {/* ножки */}
    <path d="M52 82L34 128" stroke="#243D27" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M98 82l18 46" stroke="#243D27" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M75 82v46" stroke="#243D27" strokeWidth="2.5" strokeLinecap="round" />
    {/* полочка */}
    <path d="M44 96h62" stroke="#243D27" strokeWidth="2.5" strokeLinecap="round" />
    {/* кисть на полочке */}
    <path
      d="M112 90l14-14"
      stroke="#8D414B"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M124 78l4-4"
      stroke="#243D27"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);
